module.exports = __webpack_public_path__ + "media/images/im-a-business-home-1c8f79e5.jpg";